import { render } from "./RelationshipInput.vue?vue&type=template&id=39f49654&scoped=true&ts=true"
import script from "./RelationshipInput.vue?vue&type=script&lang=ts"
export * from "./RelationshipInput.vue?vue&type=script&lang=ts"

import "./RelationshipInput.vue?vue&type=style&index=0&id=39f49654&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f49654"]])

export default __exports__